export default {
    distribution: {
      supplierPurchase: {
        "id": 32,
        "purchase_code": "G20230829000001",
        "ext_code": "",
        "ext_id": null,
        "stock_id": 28,
        "quality_is_received": 0,
        "is_received": 0,
        "quality_receive_user_id": 0,
        "receive_user_id": 0,
        "is_quality_checked": 0,
        "supplier_id": 132,
        "hope_delivery_date": "2023/08/30",
        "status": 2,
        "delivery_flg": false,
        "origin_flg": "101",
        "order_code": null,
        "supplier_account_id": null,
        "stock_order_code": null,
        "memo": "",
        "complete_date": null,
        "send_times": 0,
        "stock_out_json": null,
        "delete_flg": false,
        "created_id": 1,
        "created": "2023/08/29 15:10:08",
        "modified_id": 1,
        "modified": "2023/08/29 15:10:13",
        "third_return": null,
        "check_flg": 0,
        "delivery_date": null,
        "total": "2.00",
        "total_num": 2,
        "order_id": null,
        "purchase_details": [
          {
            "id": 43,
            "purchase_id": 32,
            "material_id": 636,
            "material_name": "商品",
            "material_code": "code",
            "category_name": "分类",
            "supplier_material_id": null,
            "unit": "瓶",
            "material_bar_code": null,
            "rate": 1,
            "quantity": 1,
            "default_quantity": "1.000000",
            "qualify_flg": 0,
            "default_unit": "瓶",
            "examine_num": "0",
            "default_examine_num": "0.000000",
            "examine_memo": null,
            "tax_flg": 0,
            "tax_rate": 0,
            "negotiate_price_flg": 0,
            "price": 1,
            "memo": "",
            "production_date": null,
            "expired_date": null,
            "standard_name": "",
            "standard_detail_id": 864,
            "bestbefore": null,
            "weight_rate": null,
            "weight_flg": 0,
            "before_tax_price": 1,
            "after_tax_price": 1,
            "total": "1.00",
            "after_tax_total": "1.00",
            "before_tax_total": "1.00",
            "supply_code": "",
            "delivery_num": 0,
            "print_delivery_num": 1,
            "prices": 1
          },
          {
            "id": 44,
            "purchase_id": 32,
            "material_id": 638,
            "material_name": "商品2",
            "material_code": "code2",
            "category_name": "分类",
            "supplier_material_id": null,
            "unit": "袋",
            "material_bar_code": null,
            "rate": 1,
            "quantity": 1,
            "default_quantity": "1.000000",
            "qualify_flg": 0,
            "default_unit": "袋",
            "examine_num": "0",
            "default_examine_num": "0.000000",
            "examine_memo": null,
            "tax_flg": 0,
            "tax_rate": 0,
            "negotiate_price_flg": 0,
            "price": 1,
            "memo": "",
            "production_date": null,
            "expired_date": null,
            "standard_name": "",
            "standard_detail_id": 866,
            "bestbefore": null,
            "weight_rate": null,
            "weight_flg": 0,
            "before_tax_price": 1,
            "after_tax_price": 1,
            "total": "1.00",
            "after_tax_total": "1.00",
            "before_tax_total": "1.00",
            "supply_code": "",
            "delivery_num": 0,
            "print_delivery_num": 1,
            "prices": 1
          }
        ],
        "stock_order": null,
        "purchase_detail": {
          "id": 43,
          "purchase_id": 32,
          "ext_id": null,
          "material_id": 636,
          "supplier_material_id": null,
          "quantity": 1,
          "examine_num": "0",
          "examine_memo": null,
          "qualify_flg": 0,
          "prices": 1,
          "negotiate_price_flg": 0,
          "memo": "",
          "quality_standard_img": null,
          "quality_standard": null,
          "parent_id": null,
          "production_date": null,
          "expired_date": null,
          "standard_detail_id": 864,
          "standard_name": "",
          "tax_flg": 0,
          "tax_rate": 0,
          "img": null
        },
        "creater": {
          "name": "系统管理员",
          "type": 1
        },
        "supplier": {
          "id": 132,
          "supplier_code": "00001",
          "supplier_name": "测试供应商",
          "city_1": "E7A80C13-D0D7-3771-B97E-B7C77ECBC8F2",
          "address": null,
          "manager_name": "张三",
          "manager_tel": "123",
          "bank": null,
          "account_name": null,
          "account_num": null,
          "comment": null,
          "type": 1,
          "material_multi_unit": 0,
          "order_to_purchase": 0,
          "purchase_after_set_price": 0,
          "account_id": null,
          "login_user_id": null,
          "password": null,
          "access_token": null,
          "token_expired": null,
          "tax_num": null,
          "email": null,
          "delete_flg": 0,
          "created_id": 1,
          "created": "2023/03/16 11:06:05",
          "modified_id": null,
          "modified": "2023/03/16 11:06:05",
          "stop_flg": 0,
          "business_license": null,
          "attachment": null,
          "national_tax_code": null,
          "tax_type": null,
          "province_id": null,
          "city_id": null,
          "area_id": null,
          "delivery_flg": 0,
          "delivery_modify_flg": 0,
          "bill_for_shop_examine": 0,
          "edit_material_flg": 0,
          "exceed_percent": 0,
          "low_percent": 0,
          "third_param": null,
          "supply_type": "普通供应商",
          "stop_flg_str": "启用",
          "business_license_url": "",
          "attachment_url": []
        },
        "stock": {
          "id": 28,
          "name": "默认仓库",
          "manager": null,
          "address": null,
          "tel": null,
          "province_id": null,
          "city_id": null,
          "area_id": null,
          "sorting_num_exceed": "0",
          "sorting_num_less": "0",
          "position_material_mix": 1,
          "position_batch_mix": 1,
          "code": null
        },
        "details_count": 2,
        "total_delivery_num": 0,
        "total_quantity_num": 2,
        "wait_examine_total_weight": 0,
        "examined_total_weight": 0,
        "examined_material_count": 0,
        "wait_examine_material_count": 2,
        "quantity_price_total": 2,
        "default_quantity_total": 2,
        "examine_price_total": 0,
        "NoPartExamineFlg": 0,
        "delivery_info": {
          "object": "默认仓库",
          "province_id": "",
          "city_id": "",
          "area_id": "",
          "address": "",
          "name": "默认仓库",
          "tel": ""
        },
        "status_str": "未发货",
        "delivery_flg_str": "未发货",
        "only_status_str": "待验收",
        "status_color": "#FF0000",
        "actions": {
          "notice": true,
          "edit": false,
          "delivery": false,
          "quality_check": false,
          "examine": true,
          "cancel": true,
          "confirm": false,
          "over": false,
          "check": true,
          "copy": true
        },
        "creater_name": "系统管理员",
        "check_status_str": "未查收"
      }
    },
}